import { InjectionToken } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

export interface AuthEnvironment {
    apiUrl: string;
    authentication: OpenIdConfiguration;
}

export const AUTH_ENVIRONMENT = new InjectionToken<AuthEnvironment>('AUTH_ENVIRONMENT');
